export const Layout = ({ children }: any) => {
	return <div >{children}</div>;
};
